import { Slide } from "@jelly/lesson";

import variables from "../../../../../../assets/styles/sass-resources.scss";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "The dB scale is a non linear scale depicting the acoustic level and where +3 dB (+10 dB) is equivalent to have multiply by 2 (10) the pressure amplitude. To have a better understanding of this scale, it is here proposed, after a preliminary setup of your volume, to travel along the dB scale! First, click on the “preliminary setting” button and set your volume such that you barely hear the beep (~20 dB SPL). Once this is set, select the dB scale or sound landscape and listen to the different level!",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "layout",
        data: {
          type: "table",
          options: {
            cols: 1,
            rows: 3,
            components: [
              [
                {
                  variant: "blockContainer",
                  data: {
                    block: {
                      type: "text",
                      options: {
                        data: "<b>Preliminary setting</b>",
                        scrollbars: false,
                        formatter: "html",
                      },
                    },
                    styles: {
                      textTransform: "uppercase",
                      letterSpacing: "0.25em",
                      alignItems: "flex-end",
                    },
                  },
                },
              ],
              [
                {
                  variant: "blockContainer",
                  data: {
                    block: {
                      type: "text",
                      options: {
                        data:
                          "Click on the “preliminary setting” button and set</br>your volume such that you barely hear the beep</br>(~20 dB SPL). Once this is set, go to next slide.",
                        scrollbars: false,
                        formatter: "html",
                      },
                    },
                    styles: {
                      textAlign: "center",
                      alignItems: "flex-start",
                      fontSize: "12px",
                      lineHeight: "18px",
                      fontWeight: 400,
                    },
                  },
                },
              ],
              [
                {
                  variant: "blockContainer",
                  data: {
                    block: {
                      type: "audioButton",
                      options: {
                        theme: "default",
                        text: "preliminary setting",
                        icon: "cis-volume-high",
                        shape: "round",
                        size: "standard",
                        loop: true,
                        url: `${config.ASSETS_URL}/01/22/principle/slide-1.wav`,
                      },
                    },
                    styles: {
                      alignItems: "flex-start",
                    },
                  },
                },
              ],
            ],
          },
          styles: {
            background: variables["primary-extra-light"],
            borderRadius: "10px",
          },
        },
      },
    },
    styles: {
      padding: "15% 15%",
    },
  },
};

export default principle;
